import React from 'react'
import { connect } from 'react-redux'
import { DynamicModuleLoader } from 'redux-dynamic-modules'
import { Route } from 'react-router-dom'
import Loadable from 'react-loadable'
import modules, { init, cancel } from './modules'
import Loading from 'components/Loading'
import { languageChange } from 'store/siteConfig'

export default function(route) {
  const ServiceDetail = Loadable({
    loader: () => import('./ServiceDetail'),
    render(loaded, props) {
      const Component = connect(
        state => ({
          paymentAuthorizationServiceDetailState:
            state.paymentAuthorizationServiceDetailState,
          siteConfig: state.siteConfig
        }),
        {
          init,
          cancel,
          languageChange
        }
      )(loaded.default)
      return <Component {...props} />
    },
    loading: Loading
  })

  return (
    <Route
      path={`${route.match.path}/service-detail`}
      render={routeProps => (
        <DynamicModuleLoader modules={[modules(routeProps.history)]}>
          <ServiceDetail {...routeProps} />
        </DynamicModuleLoader>
      )}
    />
  )
}
